/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface AggregatedCurveFilterSingleOrder {
  orderId: number;
  priceType: AggregatedCurveFilterSingleOrder.PriceTypeEnum;
  /**
   * Step - 10 ms. Example: [-1000, -100, 0, 100, 500]
   */
  offsetsInMs: Array<number>;
  /**
   * LP ids to group into Best expected virtual LP.
   */
  lpIdsToGroup?: Array<number>;
  useClientTradePrice?: boolean;
}
export namespace AggregatedCurveFilterSingleOrder {
  export const PriceTypeEnum = {
    Mid: 'MID',
    Best: 'BEST',
    Expected: 'EXPECTED',
  } as const;
  export type PriceTypeEnum = (typeof PriceTypeEnum)[keyof typeof PriceTypeEnum];
}
